// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2OtRc","gfeWrapper":"CalendarEvent_gfeWrapper__1T-wA"};